import { WelcomeContain, WelcomeDescription, WelcomeTitle, OfflineIcon } from './Welcome.styles';

import Images from 'src/App/Images';
import { useAppSelector } from 'src/App/redux/hooks';
import { RootState } from 'src/App/redux/store';

export function ActivateInLumia() {
	const platform = useAppSelector((state: RootState) => state.app.platform);

	return (
		<WelcomeContain platform={platform}>
			<Images.GrayLogo />
			<Images.GrayLogo />
			<Images.GrayLogo />
			<Images.GrayLogo />

			<WelcomeTitle>Activate Twitch Extension in Lumia Stream</WelcomeTitle>
			<OfflineIcon>
				<Images.ActivateInLumia />
			</OfflineIcon>
			<WelcomeDescription>
				Open up Lumia Stream and make sure you turn on Twitch Extensions by heading to Commands &gt; Twitch Extensions &gt; Global Settings &gt; Turn On Global State. Then press the Off and On button
				in the top left of Lumia Stream for it to activate. Then reload this extension to get started
			</WelcomeDescription>
		</WelcomeContain>
	);
}
